<template>
  <!-- Punto de semáforo (verde/ámbar/rojo) con halo suave, como el diseño. -->
  <span class="sem-dot" :style="dotStyle" v-tip="title"></span>
</template>

<script>
  import { SEM } from './dashboard-model'
  import { tip } from '../shared/tip'

  export default {
    name: 'PrmDashSemDot',

    directives: { tip },

    props: {
      state: { type: String, default: 'green' }, // green | amber | red
      title: { type: String, default: '' },
    },

    computed: {
      dotStyle () {
        // Estado desconocido/sin datos → gris neutro (p. ej. proyecto del Portfolio sin KPIs).
        const c = SEM[this.state] || '#cbd5e1'
        return { background: c, boxShadow: `0 0 0 3px ${c}22` }
      },
    },
  }
</script>

<style lang="scss" scoped>
  .sem-dot {
    display: inline-block; width: 10px; height: 10px; border-radius: 50%;
    flex-shrink: 0; vertical-align: middle;
  }
</style>
